<template>
  <div>
    <div>
      <div style="float: left">
        <el-button type="primary" size="medium" @click="todataSourceMain"><i class="el-icon-arrow-left el-icon--left"></i>返回</el-button>
      </div>
      <div style="float: right">
        <el-button type="primary" size="medium" @click="saveDataSetDetail">保存<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </div>
    </div>

<!--    <router-link to="dataSetMain" style="color: darkblue;float:right;padding-right: 2%" @click="saveDataSetDetail">-->
<!--      保存1-->
<!--    </router-link>-->
    <!--    <router-link to="dataSetMain" style="color: darkblue;float:right;padding-right: 2%">-->
    <!--        -->
    <!--    </router-link>-->
    <div class="pageCla">
      <!--    <h1>定义数据集</h1>-->
      <el-tabs v-model="activeName" type="card" >
        <el-tab-pane label="单表查询" name="first" @mousedown="dsType('1')">单表查询</el-tab-pane>
        <el-tab-pane label="Sql语句查询" name="second" @click="dsType('2')">
          <el-form :ref="dbList" class="elformCla" :model="dbList">
            <el-form-item label="名称：" size="small">
              <label slot="label">&emsp;&emsp;&emsp;&ensp;名称：</label>
              <el-col :span="7">
                <el-input type="text" size="" v-model="dbList.dsName"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="名称：" size="small" v-if="show">
              <label slot="label">&emsp;&emsp;&emsp;&ensp;名称：</label>
              <el-col >
                <el-input type="text" size="" v-model="dbList.id"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="Sql语句查询：" size="max">
              <el-col :span="13">
<!--                <el-input type="textarea" oninput="btKeyUp" style="width: 100%" v-model="dbList.dsId"></el-input>-->
                <el-input  :value="dbList.dsId"
                           @input="e => dbList.dsId = inputVaildate(e)"  placeholder="只能输入select哟,还有特殊字符只能输入 空格 * _ < > != = % 其他的会被吃掉哟">
                </el-input>
              </el-col>
              <el-col class="button" span="2">
                <el-button type="primary" size="small" @click="analysSql">解析Sql&emsp;</el-button>
              </el-col>
            </el-form-item>
            <el-col class="buttonCla">
<!--              <el-button type="primary" size="small" @click="addCol">&emsp;新增&emsp;</el-button>-->
              <el-button type="primary" size="small" @click="dialogFormVisible = true">&emsp;新增&emsp;</el-button>
            </el-col>
            <el-table :data="tableDataSecond" style="width: 80%;margin-top: 5px;border: #ebeef5 1px solid;" >
              <el-input type="hidden" prop="index"></el-input>
              <el-table-column prop="id" label="主键id" width="150;" v-if="show" ></el-table-column>
              <el-table-column prop="ds_id" label="数据集id" width="150;" v-if="show"></el-table-column>
              <el-table-column prop="field_id" label="字段标识" width="150" sortable></el-table-column>
              <el-table-column prop="field_name" label="展示名称" width="120" sortable></el-table-column>
              <el-table-column prop="field_en_name" label="展示名称英文" width="120" sortable></el-table-column>
              <el-table-column prop="field_ch_en_name" label="展示名称中英文" width="300" sortable></el-table-column>
              <el-table-column prop="" label="操作" width="120">
                <template slot-scope="scope">
<!--                  <el-button type="text" @click="editCol(scope.row)">修改</el-button>-->
                  <el-button type="text" @click="editForm(scope)">修改</el-button>
<!--                  <el-button type="text" @click="deleteCol(scope.row)">删除</el-button>-->
                  <el-button
                    @click.native.prevent="deleteRow(scope.$index, tableDataSecond)"
                    type="text"
                    size="small">
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="自定义URL" name="third" @click="dsType('3')">自定义URL</el-tab-pane>
        <el-tab-pane label="导入Excel" name="fourth" @click="dsType('4')">导入Excel</el-tab-pane>
        <el-tab-pane label="客户查询" name="fifth" @click="dsType('5')">
          <el-form class="elformCla" :ref="cusForm" :model="cusForm">
            <el-form-item label="名称：" size="small">
              <label slot="label">&emsp;&emsp;&emsp;&emsp;名称：</label>
              <el-col :span="7">
                <el-input type="text" size="" v-model="cusForm.dsName"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="选择客户：" size="small">
              <label slot="label">&emsp;&emsp;选择客户：</label>
              <el-col :span="7">
                <el-select type="text" style="width: 100%" filterable remote :remote-method="remoteMethod" :loading="loading" placeholder="请输入关键词" v-model="cusForm.cusName" value-key="cusId">
                  <el-option type="text" v-for="(cus, index) in options"
                             :key="cus.cusId"
                             :label="cus.cusName"
                             :value="cus"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="Sql语句：" size="max">
              <label slot="label">&emsp;&emsp;&ensp;Sql语句：</label>
              <el-col :span="13">
                <el-input type="textarea" style="width: 100%" v-model="cusForm.dsId"></el-input>
              </el-col>
            </el-form-item>
            <el-col class="cusButtonCla">
<!--              <el-button type="primary" size="small" @click="cusTableAdd">&emsp;新增&emsp;</el-button>-->
              <el-button type="primary" size="small" @click="dialogFormVisibleNewSave = true">&emsp;新增&emsp;</el-button>
            </el-col>
            <el-table :data="tableDataFifth" style="width: 70%;margin-top: 5px;border: #ebeef5 1px solid;" >
              <!--            <el-table-column prop="cusName" label="客户" width="300" align="center"></el-table-column>-->
              <el-table-column prop="table_id" label="表" width="300" align="center"></el-table-column>
              <el-table-column prop="table_name" label="表名称" width="450" align="center"></el-table-column>
            </el-table>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <!--增加表单-->
      <el-dialog title="增加表单" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="saveform">
          <el-form-item label="主键id" v-if="show">
            <el-input type="hidden" prop="index"></el-input>
            <el-input v-model="saveform.id" size="small" ></el-input>
          </el-form-item>
          <el-form-item label="字段标识">
            <label slot="label" >&emsp;&emsp;&emsp;字段标识</label>
            <el-col :span="12">
              <el-input v-model="saveform.fieldId" size="small" placeholder="只能填写数据库存在的字段哟,起别的名称会影响预览操作哟"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="展示名称">
            <label slot="label">&emsp;&emsp;&emsp;展示名称</label>
            <el-col :span="12">
              <el-input v-model="saveform.fieldName" size="small"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="展示名称英文">
            <label slot="label">&emsp;展示名称英文</label>
            <el-col :span="12">
              <el-input v-model="saveform.fieldEnName" size="small"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="展示名称中英文">
            <el-col :span="12">
              <el-input v-model="saveform.fieldChEnName" size="small"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!--修改表单-->
      <el-dialog title="修改表单" :visible.sync="dialogFormVisibleEdit">
        <el-form ref="form" :model="updataform">
          <el-form-item label="主键id" v-if="show">
            <el-input type="hidden" prop="index"></el-input>
            <el-input v-model="updataform.id" size="small" ></el-input>
          </el-form-item>
          <el-form-item label="字段标识">
            <label slot="label">&emsp;&emsp;&emsp;字段标识</label>
            <el-col :span="12">
              <el-input v-model="updataform.fieldId" size="small" :disabled="true"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="展示名称">
            <label slot="label">&emsp;&emsp;&emsp;展示名称</label>
            <el-col :span="12">
              <el-input v-model="updataform.fieldName" size="small"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="展示名称英文">
            <label slot="label">&emsp;展示名称英文</label>
            <el-col :span="12">
              <el-input v-model="updataform.fieldEnName" size="small"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="展示名称中英文">
            <el-col :span="12">
              <el-input v-model="updataform.fieldChEnName" size="small"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onEditSubmit">保存</el-button>
            <el-button type="primary" @click="dialogFormVisibleEdit = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!--增加表单-->
      <el-dialog title="增加表单" :visible.sync="dialogFormVisibleNewSave">
        <el-form ref="form" :model="newSaveForm">
          <el-form-item label="客户id" v-if="show">
            <el-input v-model="newSaveForm.cusId" size="small" ></el-input>
          </el-form-item>
          <el-form-item label="表">
            <label slot="label">&emsp;&emsp;&emsp;&emsp;表</label>
            <el-col span="19">
              <el-input v-model="newSaveForm.tableId" size="small"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="表名称">
            <label slot="label">&emsp;&emsp;表名称</label>
            <el-col span="19">
              <el-input v-model="newSaveForm.tableName" size="small"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>&emsp;&emsp;
            <el-button type="primary" @click="onsaveSubmit">保存</el-button>&emsp;&emsp;
            <el-button type="primary" @click="dialogFormVisibleNewSave = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      activeName:'second',
      show: false,
      dbList:{
        index:'',
        dsId : '',
        dsName : '',
        id : '',
        dbSourceId:'',
        createDate:'',
      },
      cusForm:{
        dsName: '',
        dsId: '',
        cusName: '',
        id:'',
        dbSourceId:'',
        cusId:'',
        index:'',
      },
      tableDataSecond:[],
      tableDataFifth:[],
      //客户列表
      cusList:[],
      options:[],
      loading:false,

      //增加展示框隐藏
      dialogFormVisible: false,
      //增加弹出的表单
      saveform: {
        index:'',
        id: '',
        dsId: '',
        fieldId: '',
        fieldName: '',
        fieldEnName: '',
        fieldChEnName: '',
      },
      formLabelWidth: '120px',
      //增加表单结束

      //修改弹框隐藏
      dialogFormVisibleEdit : false,
      //修改弹出的表单
      updataform:{
        index:'',
        id: '',
        dsId: '',
        fieldId: '',
        fieldName: '',
        fieldEnName: '',
        fieldChEnName: '',
      },
      //客户查询页面新增隐藏
      dialogFormVisibleNewSave: false,
      newSaveForm: {
        tableId: '',
        tableName: '',
        dsId: ''
      }



    }
  },
  mounted(){




    sessionStorage.clear()//清除页面的sessionStorage
    //alert(this.$route.query.id);
    // if (this.$route.query.id != undefined) {
    //   this.cusForm.dbSourceId = this.$route.query.id;
    //   this.dbList.dbSourceId = this.$route.query.id;
    // }
    if (this.$route.params.avtiveName != undefined) {
      this.activeName = this.$route.params.avtiveName;
      //判断当前是第几个框,然后当做ds_type存入sessionStorage里
    }
    console.log("打印一下",this.$route.query.dataSetId)



    this.updateSelect();

    //初始化

    sessionStorage.setItem("queryId",this.$route.query.id);
    sessionStorage.setItem("querydbCode",this.$route.query.dbCode)
    this.tableDataSecond.ds_id = this.$route.query.dataSetId
    console.log("this.tableDataSecond.ds_id",this.tableDataSecond.ds_id)
    // sessionStorage.setItem("dsId",this.$route.query.dataSetId)

    if (this.activeName = "second"){
      sessionStorage.setItem("dsType","2")
    }
    console.log(sessionStorage)
    console.log(this.$route.query.id)
    console.log(this.$route.query.dbCode)
    // if (this.activeName = "first"){
    //   sessionStorage.setItem("dsType","1")
    // }
    // if (this.activeName = "second"){
    //   sessionStorage.setItem("dsType","2")
    // }
    // if (this.activeName = "third"){
    //   sessionStorage.setItem("dsType","3")
    // }
    // if (this.activeName = "fourth"){
    //   sessionStorage.setItem("dsType","4")
    // }
    // if (this.activeName = "fifth"){
    //   sessionStorage.setItem("dsType","5")
    // }
    // console.log("现在dsType的sessionStorage的值是",sessionStorage)
    this.queryCusList();


  },
  activated() {
      console.log("activated运行了")
    if (this.$route.params.addFlag == '1' && this.$route.params.dsId != undefined) {
      console.log("第一个activated运行了")
      // sessionStorage.getItem("dbList");
      this.cusForm.id = this.$route.params.dsId;
      this.queryTable(this.cusForm.id);
    }
    if (this.$route.params.list != undefined && this.$route.params.flags == '1') {
      console.log("第2个activated运行了")
      // sessionStorage.getItem("dbList");
      this.tableDataSecond = this.$route.params.list;
    }
  },
  methods:{
    //初始化修改查询
    updateSelect(){
      let dataSet = this.$route.query.dataSetId;
      this.$http.get("/dbManage/sys-dataset/queryDataByTreeKey",{
        params:{
          dataSetId:this.$route.query.dataSetId//后台:前台
        }
      }).then(resp =>{
        this.tableDataSecond = resp.data
        this.dbList.dbSourceId = resp.data[0].db_source_id
        this.dbList.index = resp.data[0].ds_type
        this.dbList.dsName = resp.data[0].dsName
        this.dbList.dsId = resp.data[0].dataSetId
        this.dbList.id = resp.data[0].dsId
        this.dbList.createDate = resp.data[0].create_date
        console.log("初始化修改查询的值有1", this.dbList)
        console.log("初始化修改查询的值有",resp)
      })
    console.log("打印dataSet哟",dataSet)
    },


    judgeSql(e){
      console.log(e)
    },
    //限制 sql查询输入特殊字符
    inputVaildate(value, number = 200) {
      if(value == "update"){
        this.$message("这是查询方法,请不要用update哟")
        return ;
      }
      if(value == "insert"){
        this.$message("这是查询方法,请不要用insert")
        return ;
      }
      if(value == "delete"){
        this.$message("这是查询方法,请不要用delete")
        return ;
      }
      value = value.replace(/[`~@#$^&\-+?:"{}|/;'~@#￥……&——\-{}|《》？：“”【】；‘’。、]/g, '');
      if (value.length >= number) {
        this.$message({
          type: "warning",
          message: `输入内容不能超过${number}个字符`
        });
      }
      return value;
    },
    //定义dsType
    dsType(type){
      alert("success")
      if (type=1){
        sessionStorage.setItem("dsType","1")
      }
      if (type=2){
        sessionStorage.setItem("dsType","2")
      }
      if (type=3){
        sessionStorage.setItem("dsType","3")
      }
      if (type=4){
        sessionStorage.setItem("dsType","4")
      }
      if (type=5){
        sessionStorage.setItem("dsType","5")
      }
      console.log("现在dsType的sessionStorage的值是",sessionStorage)
    },
    //前端假删除
    deleteRow(index, rows) {
      //sessionStorage.removeItem('defineData'+index)
      rows.splice(index, 1);

      console.log("列表现在是",this.tableDataSecond)
      // console.log("删除之后的sessionStorage",sessionStorage)
    },
    //点击页面新增 弹出框的增加方法
    addCol(){
      alert(this.dbList.id)
      // this.$router.push({name:'addDataSetCol', params:{ds_id: this.dbList.id}});
    },

    //点击修改
    editForm(scope){
      console.log(scope)

      this.$set(this.updataform,'index',scope.$index);
      this.$set(this.updataform,'id',scope.row.id);
      this.$set(this.updataform,'dsId',scope.row.ds_id);
      this.$set(this.updataform,'fieldId',scope.row.field_id);
      this.$set(this.updataform,'fieldName',scope.row.field_name);
      this.$set(this.updataform,'fieldEnName',scope.row.field_en_name);
      this.$set(this.updataform,'fieldChEnName',scope.row.field_ch_en_name);

      //修改弹框展示
      this.dialogFormVisibleEdit = true;
    },
    //客户查询页面增加提交
    onsaveSubmit() {

      // alert(1)
      // this.tableDataFifth.push({
      //   table_id:this.newSaveForm.fieldChEnName,
      //   table_name:this.newSaveForm.fieldEnName,
      //
      // },alert(2))
      this.$http.post("/dbManage/sys-dataset-detail/addDataSet", this.newSaveForm).then(resp=>{
      })
      this.dialogFormVisibleNewSave = false;
    },

    //增加提交
    onSubmit(){

      for(let i=0;i<this.tableDataSecond.length;i++){
        let saveid = JSON.stringify(this.saveform.fieldId)
        let tableid =JSON.stringify(this.tableDataSecond[i].field_id)
        console.log(saveid)
        console.log(tableid)
        console.log(saveid == tableid)
        if(saveid == tableid){
          if(true){
            this.$message("此字段标识的名字已被其他小朋友起走了请换个新名字哟")
            return ;
          }
        }
      }


      for(let i=0;i<this.tableDataSecond.length;i++){
        let savename = JSON.stringify(this.saveform.fieldName)
        let tablename =JSON.stringify(this.tableDataSecond[i].field_name)
        console.log(savename)
        console.log(tablename)
        console.log(savename == tablename)
        if(savename == tablename){
          if(true){
            this.$message("这个展示名称的名字已被其他小朋友起走了请换个新名字哟")
            return ;
          }
        }
      }


      for(let i=0;i<this.tableDataSecond.length;i++){
        let saveenname = JSON.stringify(this.saveform.fieldEnName)
        let tableenname =JSON.stringify(this.tableDataSecond[i].field_en_name)
        console.log(saveenname)
        console.log(tableenname)
        console.log(saveenname == tableenname)
        if(saveenname == tableenname){
          if(true){
            this.$message("这个展示名称英文的名字已被其他小朋友起走了请换个新名字哟")
            return ;
          }
        }
      }


      for(let i=0;i<this.tableDataSecond.length;i++){
        let savecnenname = JSON.stringify(this.saveform.fieldChEnName)
        let tablecnenname =JSON.stringify(this.tableDataSecond[i].field_ch_en_name)
        console.log(savecnenname)
        console.log(tablecnenname)
        console.log(savecnenname == tablecnenname)
        if(savecnenname == tablecnenname){
          if(true){
            this.$message("这个展示名称中英文的名字已被其他小朋友起走了请换个新名字哟")
            return ;
          }
        }
      }



      if(this.saveform.fieldId == ""){
        this.$message("字段标识不能为空")
        return ;
      }
      if(this.saveform.fieldId == null){
        this.$message("字段标识不能为空")
        return ;
      }

      if(this.saveform.fieldName == ""){
        this.$message("展示名称不能为空")
        return ;
      }
      if(this.saveform.fieldName == null){
        this.$message("展示名称不能为空")
        return ;
      }

      if(this.saveform.fieldEnName == ""){
        this.$message("展示名称英文不能为空")
        return ;
      }
      if(this.saveform.fieldEnName == null){
        this.$message("展示名称英文不能为空")
        return ;
      }

      if(this.saveform.fieldChEnName == ""){
        this.$message("展示名称中英文不能为空")
        return ;
      }
      if(this.saveform.fieldChEnName == null){
        this.$message("展示名称中英文不能为空")
        return ;
      }


      this.tableDataSecond.push({
        id:this.saveform.id,
        field_ch_en_name:this.saveform.fieldChEnName,
        field_en_name:this.saveform.fieldEnName,
        field_name:this.saveform.fieldName,
        field_id:this.saveform.fieldId,
        index:this.saveform.index
      })

      // for (let i=0;i<this.tableDataSecond.length;i++){
      //   sessionStorage.setItem("defineData"+i,JSON.stringify(this.tableDataSecond[i]))
      // }
      // //this.tableDataSecond = this[type]
      // console.log("增加的值是",this.tableDataSecond);
      // console.log("增加的值之后sess是",sessionStorage);

      this.dialogFormVisible = false;

      // this.$http.post("/dbManage/sys-dataset-detail/addDatasetDetail",this.saveform).then(
      //   console.log(this.saveform),
      //   this.dialogFormVisible = false,
      //   this.saveform=''
      // )
    },
    //修改提交
    onEditSubmit(){

      // for(let i=0;i<this.tableDataSecond.length;i++){
      //   let updataid = JSON.stringify(this.updataform.fieldId)
      //   let tableid =JSON.stringify(this.tableDataSecond[i].field_id)
      //   console.log(updataid)
      //   console.log(tableid)
      //   console.log(updataid == tableid)
      //   if(updataid == tableid){
      //     if(true){
      //       this.$message("此字段标识的名字已被其他小朋友起走了请换个新名字哟")
      //       return ;
      //     }
      //   }
      // }


      for(let i=0;i<this.tableDataSecond.length;i++){
        let updataname = JSON.stringify(this.updataform.fieldName)
        let tablename =JSON.stringify(this.tableDataSecond[i].field_name)
        console.log(updataname)
        console.log(tablename)
        console.log(updataname == tablename)
        if(updataname !="undefined"){
          if(updataname != ""){
            if(updataname != null){
              if(updataname == tablename){
                if(true){
                  this.$message("这个展示名称的名字已被其他小朋友起走了请换个新名字哟")
                  return ;
                }
              }
            }
          }
        }

      }


      for(let i=0;i<this.tableDataSecond.length;i++){
        let updataenname = JSON.stringify(this.updataform.fieldEnName)
        let tableenname =JSON.stringify(this.tableDataSecond[i].field_en_name)
        console.log(updataenname)
        console.log(tableenname)
        console.log(updataenname == tableenname)
        if(updataenname !="undefined"){
          if(updataenname != ""){
            if(updataenname != null){
              if(updataenname == tableenname){
                if(true){
                  this.$message("这个展示名称英文的名字已被其他小朋友起走了请换个新名字哟")
                  return ;
                }
              }
            }
          }
        }
      }


      for(let i=0;i<this.tableDataSecond.length;i++){
        let updatacnenname = JSON.stringify(this.updataform.fieldChEnName)
        let tablecnenname =JSON.stringify(this.tableDataSecond[i].field_ch_en_name)
        console.log(updatacnenname)
        console.log(tablecnenname)
        console.log(updatacnenname == tablecnenname)

        if(updatacnenname !="undefined"){
          if(updatacnenname != ""){
            if(updatacnenname != null){
              if(updatacnenname == tablecnenname){
                if(true){
                  this.$message("这个展示名称中英文的名字已被其他小朋友起走了请换个新名字哟")
                  return ;
                }
              }
            }
          }
        }


      }



      if(this.updataform.fieldId == ""){
        this.$message("字段标识不能为空")
        return ;
      }
      if(this.updataform.fieldId == null){
        this.$message("字段标识不能为空")
        return ;
      }
      if(this.updataform.fieldName == ""){
        this.$message("展示名称不能为空")
        return ;
      }
      if(this.updataform.fieldName == null){
        this.$message("展示名称不能为空")
        return ;
      }
      if(this.updataform.fieldEnName == ""){
        this.$message("展示名称英文不能为空")
        return ;
      }
      if(this.updataform.fieldEnName == null){
        this.$message("展示名称英文不能为空")
        return ;
      }
      if(this.updataform.fieldChEnName == ""){
        this.$message("展示名称中英文不能为空")
        return ;
      }
      if(this.updataform.fieldChEnName == null){
        this.$message("展示名称中英文不能为空")
        return ;
      }


      this.$set(this.tableDataSecond[this.updataform.index],'id',this.updataform.id)
      this.$set(this.tableDataSecond[this.updataform.index],'field_name',this.updataform.fieldName)
      this.$set(this.tableDataSecond[this.updataform.index],'field_id',this.updataform.fieldId)
      this.$set(this.tableDataSecond[this.updataform.index],'field_en_name',this.updataform.fieldEnName)
      this.$set(this.tableDataSecond[this.updataform.index],'field_ch_en_name',this.updataform.fieldChEnName)
      this.$set(this.tableDataSecond[this.updataform.index],'index',this.updataform.index)


        // sessionStorage.setItem("defineData"+this.updataform.index,JSON.stringify(this.tableDataSecond[this.updataform.index]))
      console.log("修改的",this.tableDataSecond[this.updataform.index])
      // console.log("修改之后的sessionStorage是",sessionStorage)
      //
      // for (let i=0;i<this.tableDataSecond.length;i++){
      //   this.$set(this.tableDataSecond[i],'id',this.updataform.id)
      //   this.$set(this.tableDataSecond[i],'field_id',this.updataform.fieldId)
      //   this.$set(this.tableDataSecond[i],'field_name',this.updataform.fieldName)
      //   this.$set(this.tableDataSecond[i],'field_en_name',this.updataform.fieldEnName)
      //   this.$set(this.tableDataSecond[i],'field_ch_en_name',this.updataform.fieldChEnName)
      //   console.log("加i",this.tableDataSecond[i])
      // }

      //this.$set(arr, index, value)
      //表格 = 修改表单
      // this.tableDataSecond.id=this.updataform.id;
      // this.tableDataSecond.field_en_name=this.updataform.fieldEnName;
      // this.tableDataSecond.field_ch_en_name=this.updataform.fieldChEnName;
      // this.tableDataSecond.field_name=this.updataform.fieldName;
      // this.tableDataSecond.field_id=this.updataform.fieldId;

      // console.log("循环之后的 ",this.tableDataSecond)
      // console.log("修改的值是",this.tableDataSecond.field_en_name);
      // console.log("现在表格里的值有",this.tableDataSecond)

      //关闭修改弹窗
      this.dialogFormVisibleEdit = false;
    },




    // editCol(row){
    //   this.$router.push({name:'addDataSetCol', params:{
    //       id:row.id,
    //       ds_id:row.ds_id,
    //       field_id: row.field_id,
    //       field_name:row.field_name,
    //       field_en_name:row.field_en_name,
    //       field_ch_en_name:row.field_ch_en_name, flag:'edit'}
    //   });
    // },
    // deleteCol(row){
    //   let params = {id: row.id}
    //   this.$http.post("/dbManage/sys-dataset-detail/deleteCol", params).then(resp=>{
    //     this.tableDataSecond = resp.data;
    //   })
    // },
    //解析Sql
    analysSql(){
      console.log(sessionStorage)
      var params = {
        sqlContent: this.dbList.dsId,
        dbCode:this.$route.query.dbCode
      }
      this.$http.post("/dbManage/sys-dataset-detail/analysSql",params).then(resp=>{
        console.log("后端传来的是",resp.data)
        // this.tableDataSecond = resp.data;
        this.tableDataSecond.push(...resp.data)
        console.log("table赋值的是",this.tableDataSecond)
        let  queryId = sessionStorage.getItem("queryId");
        if(queryId == undefined){
          this.dbList.id = resp.data[0].ds_id;
        }else {
          this.dbList.id = queryId;
        }

        this.saveform.dsId =resp.data[0].ds_id;

        // for (let i=0;i<this.tableDataSecond.length;i++){
        //   sessionStorage.setItem("defineData"+i,JSON.stringify(this.tableDataSecond[i]))
        // }
        // console.log("sessionStorage里有",sessionStorage)

      })
    },
    //保存页面输入信息
    saveDataSetDetail(){

      for (let i=0;i<this.tableDataSecond.length;i++){

        if(this.tableDataSecond[i].field_name==null){
          alert("展示名称不能为空")
          return ;
        }
        if(this.tableDataSecond[i].field_en_name==null){
          alert("展示名称英文不能为空")
          return ;
        }
        if(this.tableDataSecond[i].field_ch_en_name==null){
          alert("展示名称中英文不能为空")
          return ;
        }
      }
      for (let i=0;i<this.tableDataSecond.length;i++){
        sessionStorage.setItem("defineData"+i,JSON.stringify(this.tableDataSecond[i]))
      }
      //把名称跟sql存进sessionStorage
      console.log("这就是dsName",this.dbList.dsName)
      console.log(this.dbList.dsId)
      sessionStorage.setItem("dsName",this.dbList.dsName);
      sessionStorage.setItem("dsId",this.dbList.id);
      sessionStorage.setItem("sql",this.dbList.dsId);
      sessionStorage.setItem("createDate",this.dbList.createDate)
      //this.tableDataSecond = this[type]
      console.log("提交的",this.tableDataSecond);
      console.log("提交的之后sess是",sessionStorage);

      if(this.tableDataSecond.length == 0){
        this.$message.warning("抱歉您还没有进行解析,不能进行提交")
      }else {
        this.$http.post("/dbManage/sys-dataset/saveInfo",sessionStorage).then(resp =>{

          this.$router.push(`/dataSetMain`)
        })
      }


    },
    todataSourceMain(){
      this.$router.push({
        name:'dataSourceMain',
        params:{
          dbCode:this.$route.query.dbCode
        }
      })
    },
    // saveDataSetDetail(){
    //   if (this.activeName == 'second') {
    //     this.$http.post("/dbManage/sys-dataset/saveInfo", this.dbList).then(resp=>{
    //       this.$alert('保存成功！','提示信息',{
    //         confirmButtonText: '确定',
    //       })
    //     })
    //   }
    //   if (this.activeName == 'fifth') {
    //     this.cusForm.cusName = this.cusForm.cusName.cusName;
    //     this.cusForm.cusId = this.cusForm.cusName.cusId;
    //     this.$http.post("/dbManage/sys-dataset/saveDataSet", this.cusForm).then(resp=>{
    //       this.$alert('保存成功！','提示信息',{
    //         confirmButtonText: '确定',
    //       })
    //     })
    //   }
    // },
    //查询客户列表
    queryCusList(){
      const that = this;
      this.$http.post("/dbManage/sys-dataset-detail/queryCusList").then(resp=>{
        that.cusList = resp.data;

        that.$forceUpdate();
      })
    },
    //客户查询-新增
    cusTableAdd(){
      this.$router.push({name:'addDataSet', params:{dsId: this.cusForm.id}});
    },
    queryTable(dsId){
      var params = {dsId: dsId}
      this.$http.post("/dbManage/sys-dataset-detail/queryData",params).then(resp=>{
        console.log(resp.data)
        this.tableDataFifth = resp.data;
      })
    },
    remoteMethod(query) {
      const that = this;
      if (query !== '') {
        this.loading = true;
        let len = this.cusList.length;
        this.options = this.cusList.filter((item,index) => {
          if(item.cusName){
            return item.cusName.indexOf(query) > -1
          }
        })
        this.$nextTick(() => {
          that.loading = false;
        })
      } else {
        this.options = [];
      }
    }
  }
}
</script>

<style scoped>
.pageCla{
  width: 95%;
  margin-left: 2%;
  margin-top: 3%;
}
.elformCla{
  padding-left: 15%;
  padding-top: 2%;
}
.buttonCla{
  padding-left: 45%;
  padding-bottom: 5px;
}
.cusButtonCla{
  padding-left: 30%;
  padding-bottom: 5px;
}
.button{
  padding-left: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/dataSource/newdefineDataSettest.vue